import ContractsTaxiDriverUpdateRequest, {
  ContractsTaxiDriverUpdateRequestBody,
} from "./contracts-taxi-driver-update.request";

const createBody = (
  request: ContractsTaxiDriverUpdateRequest,
): ContractsTaxiDriverUpdateRequestBody => {
  return {
    disabled: request.disabled,
    description: request.description,
  };
};

const contractsTaxiDriverUpdateRequestFactory = {
  createBody,
};

export default contractsTaxiDriverUpdateRequestFactory;
